export type EmoteId = 1 | 2 | 3 | 4 | 5 | 6;

export const EMOTE_ICON_ASSET_IDS: Record<EmoteId, string> = {
  1: 'emote-icon-gg',
  2: 'emote-icon-oof',
  3: 'emote-icon-taunt',
  4: 'emote-icon-thanks',
  5: 'emote-icon-cry',
  6: 'emote-icon-cheer',
};

export const EMOTE_IDS: readonly EmoteId[] = [1, 2, 3, 4, 5, 6];
